import { lazyView } from '../../app/lazyView.js';
import type { ViewComponent } from '../../app/Shell.js';

// Layar kelompok "spo" → komponen (lihat features/PORTING.md). Dimuat terpisah (lazy).
export const views: Record<string, ViewComponent> = {
  'spo-baru': lazyView(() => import('./SpoBaru.js')),
  spo: lazyView(() => import('./SpoList.js')),
  dks: lazyView(() => import('./Dks.js')),
};
